module.exports = __webpack_public_path__ + "static/media/CoralReefConservation.9617aa95.jpg";